import React from 'react';
import './Text.css';

const TeorLeader = () => {
  return (
    <div className="textinputteor">
      <h1>Лидер</h1>
      <p className="Wtext">
        <strong>по методологии Лутошкина А.Н.</strong>
      </p>
      
      <p>
        Цель данного метода — это изучение лидерских, организаторских качеств оцениваемых. Включает оценку таких коммуникативных и организационных умений, как умение повести за собой, стать организатором, способностью создавать и поддерживать командный дух в коллективе, самодисциплину, умение решать проблемы, умение влиять на окружающих, командную работу и другие.
      </p>
      
      <p>
        В тестировании выделяются следующие шкалы:
      </p>
      
      <ol>
        <li>Искренность в самооценке;</li>
        <li>Умение управлять собой;</li>
        <li>Осознание цели;</li>
        <li>Умение решать проблемы;</li>
        <li>Наличие творческого подхода;</li>
        <li>Влияние на окружающих;</li>
        <li>Знание правил организаторской работы;</li>
        <li>Организаторские способности;</li>
        <li>Умение работать с группой.</li>
      </ol>
      
      <p>
        Если сумма по качеству выделенному в шкале меньше 10, то качество развито слабо, и надо работать над его совершенствованием, если больше 10, то это качество развито средне или сильно.
      </p>
      
      <h2>Определение уровня развития лидерских качеств</h2>
      <p>
        <strong>Итоговый уровень определяется как среднее арифметическое уровней операциональных умений</strong>
      </p>
      
      <h3>16-20 баллов</h3>
      <p>
        Уровень развития лидерских качеств — высокий. Имеет высокий уровень коммуникативных и организационных умений, имеет высокий потенциал занять руководящую должность (топ-менеджмент).
      </p>
      
      <h3>11-15 баллов</h3>
      <p>
        Уровень развития лидерских качеств — средний. Имеет средний уровень коммуникативных и организационных умений, имеет потенциал к тому, чтобы занять управленческую должность (менеджер среднего звена).
      </p>
      
      <h3>Менее 10 баллов</h3>
      <p>
        Уровень развития лидерских качеств — низкий. Имеет низкий уровень коммуникативных и организационных умений и будет испытывать трудности в осуществлении управленческой роли (исполнитель).
      </p>
      
      <div className="methodology-links">
        <button className="methodology-link">Перейти в Социометрию</button>
        <button className="methodology-link">Перейти в Роль в команде</button>
      </div>
    </div>
  );
};

export default TeorLeader;